import {
  createGlobalStyle,
} from 'styled-components';

import fonts from './fonts';

export const GlobalStyle = createGlobalStyle`
  ${fonts};
  a {
    color: ${props => props.theme.colors.link};
    text-decoration: none;
  }

  .rbc-overlay {
    max-height: 600px;
    overflow: auto;
  }

  // hide a notify when the tour or the modal is open
  .opened_tour .Toastify,
  .tutorial-video-open .Toastify {
    display: none;
  }

  .mobile-chat-container {
    left: 30px;
  }

  .input-text-center input {
    text-align: center;
  }

  #react-tiny-popover-container,
  .react-tiny-popover-container {
    z-index: 99999;
  }

  .popover-arrow-container-fade-in {
    display: block;
    animation: fade-in 0.2s ease-in forwards;
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
      display: none;
    }

    100% {
      opacity: 1;
      display: block;
    }
  }
`;

export * as icons from './icons';
export * as SVG from './SVG';
export * as utils from './utils';
export * from './typography';
export * from './theme';
export * from './components';


export const isMobile = window.matchMedia('(max-width: 768px)').matches && /iPhone|iPod|Android/i.test(navigator.userAgent)
